import { EnumTpStatusPedido } from "../../../../../model/enums/enum-tp-status-pedido"


export function alterarCorStatusPedido(numero: number) {

    switch (numero) {
        case EnumTpStatusPedido.AguardandoConfirmação:
            return "#F4B400"
        case EnumTpStatusPedido.Confirmado:
            return '#0F9D58' 
        case EnumTpStatusPedido.EmPreparo:
            return '#4285F4' 
        case EnumTpStatusPedido.Enviado:
            return '#3367D6' 
        case EnumTpStatusPedido.FinalizadoOuEntregue:
            return '#34A853'
        case EnumTpStatusPedido.Cancelado:
            return "#DB4437" 
        case EnumTpStatusPedido.Invalido:
            return "#9E9E9E"
        default:
            return '';
    }
}